import React from 'react';
import { cn } from '../../../lib/utils';

/**
 * ページ本文の幅と余白。広告制作ページ（/ads/*）は /ads/banner を基準にこの 1 行へ揃える。
 * 幅を変えるときはここだけ直せば全ページが切り替わる。
 */
export const TASKY_PAGE_CONTAINER_CLASS = 'mx-auto w-full max-w-6xl px-4 py-4 sm:px-6';

export type TaskyPageContainerProps = React.HTMLAttributes<HTMLDivElement>;

export const TaskyPageContainer = React.forwardRef<HTMLDivElement, TaskyPageContainerProps>(
  ({ className, children, ...rest }, ref) => (
    <div ref={ref} className={cn(TASKY_PAGE_CONTAINER_CLASS, className)} {...rest}>
      {children}
    </div>
  )
);
TaskyPageContainer.displayName = 'TaskyPageContainer';
